<div *ngIf="replyItem.isDone" class="row">
  <div *ngIf="packagingLabel.id" class="col-lg-12">
    <p class="pb-2">{{'doctrine.solution.action_packaging_label.check_file' | translate}}</p>
    <button type="button" class="btn btn-primary btn-file" (click)="openPdfFile()">
      <i class="fa fa-file-pdf-o"></i>
    </button>
  </div>
</div>
<a #downloadLink href="" download style="display: none"></a>
